<template>
</template>

<script>
export default {
  name: "SubscriptionsLicenses"
}
</script>

<style scoped>

</style>
